/* ARF Enhance v15 · Rabatt nach Nutzung ausblenden · Handy-Schnellzugriff */
(function () {
  'use strict';
  if (window.__arfEnh) return;
  window.__arfEnh = 1;
  var D = document, H = D.documentElement, W = window;

  function waitFor(sel, cb, max) {
    var t0 = Date.now();
    (function poll() {
      var el = D.querySelector(sel);
      if (el) return cb(el);
      if (Date.now() - t0 < (max || 8000)) setTimeout(poll, 150);
    })();
  }
  var idle = W.requestIdleCallback || function (f) { return setTimeout(f, 300); };

  /* ---------- 1. Rabattcode ausblenden, sobald genutzt ---------- */
  var cfg = {};
  try { cfg = JSON.parse((D.getElementById('arf-promo-cfg') || {}).textContent || '{}'); } catch (e) {}
  var KEY = 'arfPromoUsed';
  var CODE = String(cfg.code || '').toUpperCase();
  function lsUsed() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || 'null'); return !!(v && v.code === CODE && Date.now() - v.t < 7776000000); } catch (e) { return false; }
  }
  function lsSet() { try { localStorage.setItem(KEY, JSON.stringify({ code: CODE, t: Date.now() })); } catch (e) {} }
  function markUsed() {
    H.classList.add('arf-promo-used');
    waitFor('.arf-loc--mobile', function (loc) {
      if (loc.querySelector('.arf-ticket-alt')) return;
      var a = D.createElement('a');
      a.className = 'arf-ticket-alt';
      a.href = cfg.link || '/policies/shipping-policy';
      a.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 3v5c0 4.6-3 8.4-7 10-4-1.6-7-5.4-7-10V6z"/><path d="M8.8 12.2l2.2 2.2 4.4-4.6"/></svg><span></span>';
      a.lastChild.textContent = cfg.textM || 'Versand aus Deutschland';
      loc.appendChild(a);
    });
  }
  function checkCart() {
    if (H.classList.contains('arf-promo-used')) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var hit = (c.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === CODE; }) ||
                  (c.cart_level_discount_applications || []).some(function (d) { return String(d.title).toUpperCase() === CODE; });
        if (hit) { lsSet(); markUsed(); }
      }).catch(function () {});
  }
  if (CODE && cfg.hide !== false) {
    if (cfg.usedOrder || lsUsed()) markUsed();
    else {
      idle(checkCart);
      W.addEventListener('pageshow', function (e) { if (e.persisted) checkCart(); });
      D.addEventListener('visibilitychange', function () { if (!D.hidden) checkCart(); });
      /* nach jeder Warenkorb-Änderung erneut prüfen */
      try {
        var of = W.fetch;
        W.fetch = function (u) {
          var p = of.apply(this, arguments);
          try { var s = typeof u === 'string' ? u : (u && u.url) || ''; if (/\/cart\/(add|change|update|clear)|\/discount\//.test(s)) p.then(function () { setTimeout(checkCart, 400); }); } catch (e) {}
          return p;
        };
      } catch (e) {}
    }
  }

  /* ---------- 2. Handy-Schnellzugriff: aktuelle Seite markieren ---------- */
  waitFor('.arf-chips', function (n) {
    var p = location.pathname.replace(/\/$/, '');
    var as = n.querySelectorAll('a');
    for (var i = 0; i < as.length; i++) {
      var h = (as[i].getAttribute('href') || '').split('#')[0].replace(/^https?:\/\/[^/]+/, '').replace(/\/$/, '');
      if (h && p && p === h) { as[i].classList.add('is-current'); as[i].setAttribute('aria-current', 'page'); }
    }
  });
})();
